{
  "longPressMessage": "Nospiediet un paturiet, lai skatītu priekšskatījumu"
}
